import i18n from '@/lang/index'
export default {
  name: 'shop-coupon',
  label: {
    title: i18n.t('shop_coupon'),
    icon: require('@/assets/icon-component-label_ShopCoupon.svg'),
    limit: 1
  },
  decor_type: 'seller',
  sort: 998
}
